module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"thumbnails_title":"この商品の他のレビュー"}}')
  delete Component.options._Ctor
}
